import React from 'react'
import { Link } from 'react-router-dom'
import Icon from '../misc/Icons'
import { formatDate } from '../../utils/formatDate'
import { isCurrentUser } from '../../utils/isCurrentUser'
import { getLinkForRepo } from '../../utils/getLinkForRepo'

function LocalBadge({ repo }) {
  if (!repo.__localOrigin) return null
  if (repo.__localEngine === 'minisearch') {
    return <Icon name='local-source-bm25' className='searchResults-localBadge searchResults-localBadge--bm25' />
  }
  return <Icon name='local-source' className='searchResults-localBadge' />
}

class SearchResultsRepoCard extends React.Component {
  render() {
    const { repo } = this.props
    const linkPath = getLinkForRepo(repo)
    let inPublicConsumerRepo = false
    let inPublicAuthorRepo = false
    if (repo.published) {
      if (isCurrentUser(repo.author)) {
        inPublicAuthorRepo = true
      } else {
        inPublicConsumerRepo = true
      }
    }
    return (
      <Link to={linkPath}>
        <div className='searchResultsRow searchResultsRow--repo'>
          <div className='searchResultsRow-icon'>
            <Icon name='search-pack' />
          </div>
          <div className='searchResultsRow-body'>
            <div className='searchResultsRow-title'>
              <span className='searchResultsRow-title-text'>{repo.name}</span>
              {repo.shared && <Icon name='shared' />}
              {inPublicConsumerRepo && <Icon name='globe-shared' />}
              {inPublicAuthorRepo && <Icon name='globe-shared-author' />}
              <LocalBadge repo={repo} />
            </div>
            {repo.clientModified && (
              <div className='searchResultsRow-meta'>
                {'Edited '}
                {formatDate(repo.clientModified)}
              </div>
            )}
          </div>
        </div>
      </Link>
    )
  }
}

export default SearchResultsRepoCard
